import React from 'react'
import {
  faBathtub,
  faBed,
  faPerson,
  faRulerCombined
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

export interface SearchUnitAttributesProps {
  unitAttributes: {
    bedrooms: number
    bathrooms: number
    maxGuests: number
    unitSize?: string
  }
  className?: string
}

const SearchUnitAttributes = ({
  unitAttributes,
  className = ''
}: SearchUnitAttributesProps) => {
  if (!unitAttributes) {
    return null
  } else {
    const {bedrooms, bathrooms, maxGuests, unitSize} = unitAttributes
    return (
      <div className={className}>
        <div className="flex flex-row flex-wrap gap-3 text-xs font-medium">
          <div>
            <FontAwesomeIcon
              icon={faBed}
              className="text-accent mr-1"
              title="Bedrooms"
            />
            <span className="lowercase">
              {bedrooms === 1 ? '1 Bedroom' : `${bedrooms} Bedrooms`}
            </span>
          </div>
          <div>
            <FontAwesomeIcon
              icon={faBathtub}
              className="text-accent mr-1"
              title="Bathrooms"
            />
            <span className="lowercase">
              {bathrooms === 1 ? '1 Bathroom' : `${bathrooms} Bathrooms`}
            </span>
          </div>
          <div>
            <FontAwesomeIcon
              icon={faPerson}
              className="text-accent mr-1"
              title="Guests"
            />
            <span className="lowercase">
              {maxGuests === 1 ? '1 Guest' : `${maxGuests} Guests`}
            </span>
          </div>
          {unitSize && (
            <div>
              <FontAwesomeIcon
                icon={faRulerCombined}
                className="text-accent mr-1"
                title="Unit Size"
              />
              <span className="lowercase">{unitSize} sq. ft.</span>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default SearchUnitAttributes
